(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('react-intl'), require('@fortawesome/react-fontawesome'), require('clsx'), require('prop-types'), require('react-router-dom'), require('react-tooltip'), require('html-react-parser'), require('classnames')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'react-intl', '@fortawesome/react-fontawesome', 'clsx', 'prop-types', 'react-router-dom', 'react-tooltip', 'html-react-parser', 'classnames'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.soundcloud = {}, global.React, global.reactIntl, global.reactFontawesome, global.clsx, global.PropTypes, global.reactRouterDom, global.ReactTooltip, global.parse, global.classnames));
})(this, (function (exports, React, reactIntl, reactFontawesome, clsx, PropTypes, reactRouterDom, ReactTooltip, parse, classnames) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
    var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
    var ReactTooltip__default = /*#__PURE__*/_interopDefaultLegacy(ReactTooltip);
    var parse__default = /*#__PURE__*/_interopDefaultLegacy(parse);
    var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

    var Button = function Button(props) {
      var id = props.id,
        name = props.name,
        classes = props.classes,
        outerClass = props.outerClass,
        type = props.type,
        btnText = props.btnText,
        icon = props.icon,
        iconSize = props.iconSize,
        iconClassName = props.iconClassName,
        _props$iconPlacement = props.iconPlacement,
        iconPlacement = _props$iconPlacement === void 0 ? 'END' : _props$iconPlacement,
        path = props.path,
        handleClick = props.handleClick,
        dataTestId = props.dataTestId,
        _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled;
      var clickHandle = function clickHandle() {
        window.location.href = path;
      };
      var handleBtnClick = function handleBtnClick(e) {
        handleClick(e);
      };
      return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
        className: "".concat(outerClass && outerClass.join(' '))
      }, /*#__PURE__*/React__default["default"].createElement("button", {
        type: type,
        id: id,
        "data-testid": dataTestId || id,
        "data-automation-id": id,
        name: name,
        className: "gi-button ".concat(classes && classes.join(' ')),
        onClick: path ? clickHandle : handleBtnClick,
        disabled: disabled
      }, iconPlacement === 'START' && icon && /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: icon,
        size: iconSize && iconSize,
        className: iconClassName && iconClassName.join(' ')
      }), /*#__PURE__*/React__default["default"].createElement(reactIntl.FormattedMessage, {
        id: btnText
      }), iconPlacement === 'END' && icon && /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
        icon: icon,
        size: iconSize && iconSize,
        className: iconClassName && iconClassName.join(' ')
      }))));
    };

    const GIButton = (props) => {
        const { id, labelId, labelValue, label, size = '', name, isDisabled = false, type = 'submit', variant = 'primary', icon, iconPlacement = 'end', onClickHandler, addlClassNames } = props;
        const buttonClasses = clsx__default["default"]({
            [`usa-button gi-button gi-button__${variant}`]: true,
            'gi-button--small': size === 'small',
            'gi-button--medium': size === 'medium',
            'gi-button--large': size === 'large',
            'gi-button__disabled': isDisabled,
            [`${addlClassNames}`]: addlClassNames
        });
        return (React__default["default"].createElement("button", { className: buttonClasses, type: type, name: name, disabled: isDisabled, "data-automation-id": id, "data-testid": id, onClick: onClickHandler },
            !icon &&
                React__default["default"].createElement(React.Fragment, null,
                    labelId && React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId, values: labelValue }),
                    !labelId && label),
            icon && iconPlacement === 'start' &&
                React__default["default"].createElement(React.Fragment, null,
                    React__default["default"].createElement("i", { className: icon }),
                    labelId && React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId, values: labelValue }),
                    !labelId && label),
            icon && iconPlacement === 'end' &&
                React__default["default"].createElement(React.Fragment, null,
                    labelId && React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId, values: labelValue }),
                    !labelId && label,
                    React__default["default"].createElement("i", { className: icon }))));
    };
    GIButton.propTypes = {
        ariaLabel: PropTypes__default["default"].string,
        dataTestId: PropTypes__default["default"].string,
        iconName: PropTypes__default["default"].object,
        iconClassName: PropTypes__default["default"].string,
        iconPlacement: PropTypes__default["default"].oneOf(['start', 'end']),
        id: PropTypes__default["default"].string.isRequired,
        isDisabled: PropTypes__default["default"].bool,
        label: PropTypes__default["default"].string,
        labelId: PropTypes__default["default"].string,
        labelValue: PropTypes__default["default"].object,
        name: PropTypes__default["default"].string,
        onClickHandler: PropTypes__default["default"].func,
        size: PropTypes__default["default"].oneOf(['', 'small', 'medium', 'large']),
        type: PropTypes__default["default"].oneOf(['submit', 'button', 'reset']),
        variant: PropTypes__default["default"].oneOf(['primary', 'secondary', 'ghost', 'link']),
    };
    GIButton.defaultProps = {
        ariaLabel: '',
        isDisabled: false,
        size: '',
        type: 'submit',
        variant: 'primary',
    };

    const PageTitle = (props) => {
        const { labelId, labelValues } = props;
        return (React__default["default"].createElement("h1", null,
            React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId, values: labelValues })));
    };
    PageTitle.propTypes = {
        labelId: PropTypes__default["default"].string.isRequired,
        labelsValues: PropTypes__default["default"].any
    };

    const Layouts = (props) => {
        const { id, children } = props;
        return (React__default["default"].createElement("main", { className: "usa-layout-docs usa-section gi-main-section", id: id },
            React__default["default"].createElement("div", { className: "grid-container gi-grid-container" }, children)));
    };
    Layouts.Row = ({ hasGap = false, children }) => {
        const layoutsRowClasses = clsx__default["default"]({
            'grid-row': true,
            'grid-gap': hasGap,
            'gi-wrapper': true
        });
        return (React__default["default"].createElement("div", { className: layoutsRowClasses }, children));
    };
    Layouts.propTypes = {
        id: PropTypes__default["default"].string.isRequired,
        children: PropTypes__default["default"].node.isRequired
    };

    const Spinner = ({ messageId = 'spinner.loading_data' }) => {
        React.useEffect(() => {
            const disableScroll = () => window.scrollTo(0, 0);
            window.addEventListener('scroll', disableScroll);
            return () => window.removeEventListener('scroll', disableScroll);
        });
        return (React__default["default"].createElement("div", { className: "gi-roller-container" },
            React__default["default"].createElement("div", { className: "gi-roller-wrapper" },
                React__default["default"].createElement("div", { className: "gi-roller-message" },
                    React__default["default"].createElement(reactIntl.FormattedMessage, { id: messageId })),
                React__default["default"].createElement("div", { className: "gi-roller-spin" }))));
    };
    Spinner.propTypes = {
        messageId: PropTypes__default["default"].string
    };
    Spinner.defaultProps = {
        messageId: 'spinner.loading_data'
    };

    const Tabs = React.forwardRef((props, ref) => {
        const [activeTab, setActiveTab] = React.useState(0);
        const { tabs } = props;
        React.useImperativeHandle(ref, () => ({
            setActiveTab: (index) => {
                setActiveTab(index);
            }
        }));
        return (React__default["default"].createElement(React.Fragment, null,
            React__default["default"].createElement("div", { role: "tablist", className: "usa-list usa-list--unstyled grid-row gi-tabs" }, tabs.map((tab, index) => (React__default["default"].createElement("div", { className: "gi-tabs__item", key: index },
                React__default["default"].createElement("button", { role: "tab", key: index, className: activeTab === index ? 'active' : '', onClick: () => setActiveTab(index) },
                    React__default["default"].createElement(reactIntl.FormattedMessage, { id: tab.title, values: tab.titleValue })))))),
            tabs[activeTab].render()));
    });

    const CardsContext = React__default["default"].createContext(1);
    const Cards = ({ numColumns, children }) => {
        return (React__default["default"].createElement(CardsContext.Provider, { value: numColumns },
            React__default["default"].createElement("div", { className: "grid-row" },
                React__default["default"].createElement("ul", { className: "grid-col-12" }, children))));
    };
    Cards.Row = ({ children }) => {
        return (React__default["default"].createElement("li", { className: "grid-row gi-card_list" }, children));
    };
    Cards.Col = ({ children }) => {
        const context = React__default["default"].useContext(CardsContext);
        const colNum = Math.ceil(12 / context);
        return (React__default["default"].createElement("div", { className: `desktop:grid-col-${colNum} tablet:grid-col-${colNum} mobile:grid-col-12 gi-card_list_col` }, children));
    };
    Cards.propTypes = {
        numColumns: PropTypes__default["default"].number.isRequired,
        classNames: PropTypes__default["default"].string,
        children: PropTypes__default["default"].node.isRequired
    };

    const panelToggleMsg = {
        EXPANDED: React__default["default"].createElement(reactIntl.FormattedMessage, { id: 'common.hide' }),
        COLLAPSED: React__default["default"].createElement(reactIntl.FormattedMessage, { id: 'common.show' })
    };
    const CollapsiblePanel = ({ isInitialExpanded = false, header, isNoPanel = false, children }) => {
        const [expanded, setExpanded] = React.useState(isInitialExpanded);
        const toggle = (e) => {
            e.preventDefault();
            setExpanded(!expanded);
        };
        return (React__default["default"].createElement("div", { className: !isNoPanel ? 'gi-panel' : '' },
            React__default["default"].createElement("p", { className: `gi-panel__header gi-panel__header--${expanded ? 'expanded' : 'collapsed'}` }, header),
            React__default["default"].createElement("a", { className: 'gi-panel__toggle', href: "#", onClick: toggle },
                expanded ? panelToggleMsg.EXPANDED : panelToggleMsg.COLLAPSED,
                React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: expanded ? 'chevron-up' : 'chevron-down', className: "grid-col-1 icon" })),
            expanded && children));
    };
    CollapsiblePanel.propTypes = {
        header: PropTypes__default["default"].string.isRequired,
        isInitialExpanded: PropTypes__default["default"].bool,
        isNoPanel: PropTypes__default["default"].bool,
        children: PropTypes__default["default"].node.isRequired
    };
    CollapsiblePanel.defaultProps = {
        isInitialExpanded: false,
        isNoPanel: false
    };

    const HeaderNav = (props) => {
        const { hasSubMenu, isTopNav, stateCode, children } = props;
        const mainNavClasses = clsx__default["default"]({
            'main-nav-masthead': true,
            'main-nav-submenu': hasSubMenu
        });
        const headerClasses = clsx__default["default"]({
            'usa-header usa-header--basic gi-masthead': true,
            'gi-masthead_top_nav': isTopNav
        });
        return (React__default["default"].createElement("div", { className: mainNavClasses },
            React__default["default"].createElement("header", { className: headerClasses, id: `masthead-${stateCode}`, role: "banner" },
                React__default["default"].createElement("div", { className: "usa-nav-container gi-masthead__container" }, children))));
    };
    HeaderNav.propTypes = {
        isTopNav: PropTypes__default["default"].bool.isRequired,
        hasSubMenu: PropTypes__default["default"].bool.isRequired,
        stateCode: PropTypes__default["default"].oneOf(['CA', 'GA', 'ID', 'MN', 'NJ', 'NV', 'PA']).isRequired,
        children: PropTypes__default["default"].node.isRequired
    };

    const Modal = ({ classNames: classNamesStr, id, zIndex = 1000, children }) => {
        const modalClasses = clsx__default["default"]({
            'gi-modal__layout': true,
            [`${classNamesStr}`]: !!classNamesStr
        });
        return (React__default["default"].createElement("div", { className: `${modalClasses}`, style: { zIndex } },
            React__default["default"].createElement("div", { className: "modal_boundary gi-modal__content", tabIndex: 0, id: id, role: "dialog", "aria-labelledby": id, "data-modaltype": id }, children)));
    };
    Modal.Header = ({ id, titleId, onHide, titleValues }) => {
        return (React__default["default"].createElement("div", { className: "gi-modal__header__head" },
            React__default["default"].createElement("div", { className: "gi-modal__header", id: id },
                React__default["default"].createElement("h3", { "data-testid": id }, titleValues ? React__default["default"].createElement(reactIntl.FormattedMessage, { id: titleId, values: titleValues }) : React__default["default"].createElement(reactIntl.FormattedMessage, { id: titleId })),
                React__default["default"].createElement("div", { className: "gi-modal__btn--close" },
                    React__default["default"].createElement("a", { id: "close-button-icon", href: "#", "aria-label": "Close", onClick: onHide },
                        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: "times", "data-automation-id": `${id}_close` }))))));
    };
    Modal.Body = ({ children, id }) => {
        return (React__default["default"].createElement("div", { "data-testid": id, className: "gi-modal__body", "aria-describedby": id }, children));
    };
    Modal.Controls = ({ children }) => {
        return (React__default["default"].createElement("div", { className: "gi-modal__controls" }, children));
    };
    Modal.propTypes = {
        id: PropTypes__default["default"].string.isRequired,
        classNames: PropTypes__default["default"].string,
        zIndex: PropTypes__default["default"].number,
        children: PropTypes__default["default"].node.isRequired
    };
    Modal.defaultProps = {
        zIndex: 1000
    };

    // components
    const NavBar = ({ classNames: classNamesStr, hasCloseButton, children }) => {
        const navBarClasses = clsx__default["default"]({
            'usa-nav gi-main__nav': true,
            [`${classNamesStr}`]: !!classNamesStr
        });
        return (React__default["default"].createElement("nav", { role: "navigation", className: navBarClasses },
            !!hasCloseButton &&
                React__default["default"].createElement("button", { "aria-label": "Close", className: "usa-nav__close gi-main__nav__close" },
                    React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: "times" })),
            React__default["default"].createElement("ul", { className: "usa-nav__primary usa-accordion main__nav__links-container" }, children)));
    };
    NavBar.Item = ({ children }) => {
        return (React__default["default"].createElement("li", { className: "usa-nav__primary-item gi-main__nav__primary-item" }, children));
    };
    NavBar.Link = ({ id, iconName, url, label, labelId, ariaLabel, render, isShowInNewTab }) => {
        const target = isShowInNewTab ? '_blank' : '_self';
        return (React__default["default"].createElement("a", { href: url, className: "usa-nav__link gi-main__nav__primary-item__link secured-mail", target: target, "aria-label": ariaLabel, id: id, "data-automation-id": id },
            render &&
                render(),
            !render &&
                React__default["default"].createElement("span", null,
                    iconName &&
                        // @ts-ignore
                        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: iconName, key: iconName, "data-automation-id": `${id}` }),
                    ' ',
                    label &&
                        React__default["default"].createElement("span", null, label),
                    labelId &&
                        React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId }))));
    };
    NavBar.Menu = ({ children, ...restProps }) => {
        const { id, label, labelId, iconName } = restProps;
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement("button", { id: id, "data-automation-id": id, className: " usa-accordion__button usa-nav__link dropdown__pos dropdown__pos--01 ", "aria-expanded": "false", "aria-controls": `extended-nav-section-${id}` },
                iconName &&
                    // @ts-ignore
                    React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: iconName, key: iconName, "data-automation-id": `${id}` }),
                ' ',
                label &&
                    React__default["default"].createElement("span", null, label),
                labelId &&
                    React__default["default"].createElement("span", null,
                        React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId })),
                React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: "caret-down", "data-automation-id": `${id}_caret_down` })),
            React__default["default"].createElement("ul", { className: "usa-nav__submenu gi-main__nav__submenu", id: `extended-nav-section-${id}`, hidden: true }, children)));
    };
    NavBar.SubMenuItem = ({ id, url, label, labelId, isDisabled = false, isShowInNewTab, iconName, render }) => {
        const target = isShowInNewTab ? '_blank' : '_self';
        const subMenuitemClasses = clsx__default["default"]({
            'usa-nav__submenu-item': true,
            'cursor-pointer': !isDisabled
        });
        return (React__default["default"].createElement("li", { className: subMenuitemClasses },
            render &&
                render(),
            !render &&
                React__default["default"].createElement("a", { href: url, id: id, "data-automation-id": id, target: target, rel: "noopener noreferrer", title: "Link opens in a new window or a new tab" },
                    iconName &&
                        // @ts-ignore
                        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: iconName, key: iconName, "data-automation-id": `${id}` }),
                    label &&
                        React__default["default"].createElement("span", null, label),
                    labelId &&
                        React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId }))));
    };
    NavBar.SubMenuActionItem = ({ id, labelId, onClickHandler }) => {
        return (React__default["default"].createElement("li", { className: "usa-nav__submenu-item" },
            React__default["default"].createElement("a", { href: '#', id: id, "data-automation-id": id, onClick: onClickHandler },
                React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId }))));
    };
    NavBar.propTypes = {
        hasCloseButton: PropTypes__default["default"].bool,
        classNames: PropTypes__default["default"].string,
        children: PropTypes__default["default"].node.isRequired
    };

    const PrivateRoute = (props) => {
        const { element, isAllowed, path, redirectPath, ...rest } = props;
        if (!isAllowed) {
            return React__default["default"].createElement(reactRouterDom.Navigate, { to: redirectPath || '/hix/anonymous/errorPage' });
        }
        return (React__default["default"].createElement(reactRouterDom.Route, { ...rest, path: path, element: element }));
    };
    PrivateRoute.propTypes = {
        path: PropTypes__default["default"].string.isRequired,
        isAllowed: PropTypes__default["default"].bool.isRequired,
        redirectPath: PropTypes__default["default"].string,
        element: PropTypes__default["default"].element.isRequired
    };
    PrivateRoute.defaultProps = {
        redirectPath: '/hix/anonymous/errorPage'
    };

    // components
    const SideNavItemContext = React__default["default"].createContext(false);
    const SideNav = ({ children }) => {
        return (React__default["default"].createElement("nav", { "aria-label": "Secondary navigation" },
            React__default["default"].createElement("div", { className: 'usa-sidenav gi-sidebar_nav' }, children)));
    };
    SideNav.Header = ({ labelId, iconName, iconPrefix = 'fas' }) => {
        return (React__default["default"].createElement("div", { className: "header" },
            React__default["default"].createElement("h3", { className: 'heading' },
                iconName && iconPrefix &&
                    // @ts-ignore
                    React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: [iconPrefix, iconName], className: "icon" }),
                ' ',
                React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId }))));
    };
    SideNav.Item = ({ hasIcon = false, children }) => {
        return (React__default["default"].createElement(SideNavItemContext.Provider, { value: hasIcon },
            React__default["default"].createElement("ul", { className: "usa-list usa-list--unstyled gi-sidebar_nav_list" }, children)));
    };
    SideNav.Link = ({ labelId, labelText, name, url, cursorNotAllowed = false, isSelectedDefault = false, iconName, isShowLinkInNewWindow = false }) => {
        const [isSelected, setIsSelected] = React.useState(false);
        const linkClasses = clsx__default["default"]({
            'usa-sidenav__item gi-sidebar_nav_list_item': true,
            ['usa-sidenav__item__selected gi-sidebar_nav_list_item_active']: isSelected || isSelectedDefault
        });
        const onClickHandler = () => {
            setIsSelected(!isSelected);
        };
        return (React__default["default"].createElement("li", { className: linkClasses },
            React__default["default"].createElement("div", { className: "grid-row display--flex align-items-center" },
                React__default["default"].createElement("a", { href: url, target: isShowLinkInNewWindow ? '_blank' : undefined, id: name, onClick: onClickHandler, className: `grid-col-auto ${cursorNotAllowed && 'cursor-not-allowed'}` },
                    iconName &&
                        // @ts-ignore
                        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: iconName, className: "icon" }),
                    labelText || React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId })))));
    };
    SideNav.ActionLink = ({ labelId, iconName, isSelectedDefault = false, onClickHandler }) => {
        const [isSelected, setIsSelected] = React.useState(false);
        const linkClasses = clsx__default["default"]({
            'usa-sidenav__item gi-sidebar_nav_list_item': true,
            ['usa-sidenav__item__selected gi-sidebar_nav_list_item_active']: isSelected || isSelectedDefault
        });
        const onEventClickHandler = () => {
            setIsSelected(!isSelected);
            onClickHandler();
        };
        return (React__default["default"].createElement("li", { className: linkClasses },
            React__default["default"].createElement("div", { className: "grid-row cursor-pointer display--flex align-items-center" },
                React__default["default"].createElement("a", { href: "javascript:void(0)", onClick: onEventClickHandler, id: 'side-nav-action-link-none' },
                    iconName &&
                        // @ts-ignore
                        React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: iconName, className: "icon" }),
                    React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId })))));
    };

    const Table = (props) => {
        const { data, columns, hasBorders = false, showAllHeaders = false, classNamesStr, onSelectRow = () => { } } = props;
        const tableHeader = (React__default["default"].createElement("thead", null,
            React__default["default"].createElement("tr", null, columns.map(column => {
                return (React__default["default"].createElement("th", { key: column.key, scope: "col" },
                    React__default["default"].createElement("span", null,
                        React__default["default"].createElement(reactIntl.FormattedMessage, { id: column.titleId }))));
            }))));
        const tableBody = (React__default["default"].createElement("tbody", null, data.map((row, rowIdx) => (React__default["default"].createElement("tr", { key: rowIdx, onClick: () => { typeof onSelectRow === 'function' && onSelectRow(rowIdx); }, className: `${(row === null || row === void 0 ? void 0 : row.isSelected) ? '_selected' : '_unselected'}` }, columns.map((column, colIdx) => {
            return (React__default["default"].createElement("td", { key: colIdx },
                column.render &&
                    column.render(row),
                !column.render &&
                    React__default["default"].createElement("span", null, row[column.key])));
        }))))));
        const tableClasses = clsx__default["default"]({
            'usa-table gi-table': true,
            'gi-table-show-all-headers': showAllHeaders,
            'usa-table--borderless': !hasBorders,
            [`${classNamesStr}`]: !!classNamesStr
        });
        return (React__default["default"].createElement("div", { className: 'gi-table__responsive' },
            React__default["default"].createElement("table", { className: tableClasses },
                tableHeader,
                tableBody)));
    };
    Table.propTypes = {
        hasBorders: PropTypes__default["default"].bool,
        classNamesStr: PropTypes__default["default"].string,
        data: PropTypes__default["default"].any.isRequired,
        columns: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
            titleId: PropTypes__default["default"].string.isRequired,
            key: PropTypes__default["default"].string.isRequired,
            render: PropTypes__default["default"].func
        }))
    };
    Table.defaultProps = {
        hasBorders: false,
        showAllHeaders: false
    };

    /**
     * id - trigger id (used for Formatted message to render trigger text). It is not used for tooltip where trigger is icon;
     * content - content id for Formatted Message or whole html which will be rendered;
     * index - unique identifier to construct unique data-for attributes;
     * replacement - object for trigger value;
     * icon - If this param is passed, tooltip's trigger is not text, but an icon;
     * triggerClassName - custom class names for trigger;
     * contentClassName - custom class names for content;
     * triggerDecorationClassName - by default all tooltips have dotted bottom border;
     * dataAutomationId - optional prop needed for automation QA.
     * plain - when content is a dynamic value, which does not need to be parsed(translated)
     *
     * @param props
     * @returns {*}
     * @constructor
     */
    const Tooltip = (props) => {
        const { id, elementId = undefined, content, index, href, replacement, place = 'top', type = 'dark', effect = 'solid', icon = undefined, empty = false, triggerClassName = '', contentClassName = '', triggerDecorationClassName = 'tooltip-base', dataAutomationId = undefined, plain = false, multiline = false, contentReplacement, onClickHandler } = props;
        const intlApi = reactIntl.useIntl();
        let tRef = null;
        const onKeyUpEvent = (e, tooltipRef) => {
            // check for Esc key
            if (e.keyCode === 27) {
                hideTooltip(tooltipRef);
            }
        };
        const hideTooltip = (tooltipRef) => {
            ReactTooltip__default["default"].hide(tooltipRef);
        };
        const showTooltip = (tooltipRef) => {
            ReactTooltip__default["default"].show(tooltipRef);
        };
        const uniqueIdentifier = () => icon ? `tooltip_${index}` : elementId ? `${elementId}_tooltip_${index}` : `${id}_tooltip_${index}`;
        const defineLinkPropsIfLink = () => href ? { href, target: '_blank', rel: 'noopener noreferrer' } : {};
        const getTooltipTriggerType = () => {
            if (icon) {
                return React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, { icon: icon }); // icon, not text;
            }
            else if (plain) {
                return id; // dynamic text, no need to parse/translate;
            }
            else if (!empty) {
                return React__default["default"].createElement(reactIntl.FormattedMessage, { id: id, values: replacement }); // i18n id, will be translated;
            }
            return null;
        };
        const tooltipTriggerType = getTooltipTriggerType();
        return React__default["default"].createElement("span", { className: 'ga-tooltip-container' },
            React__default["default"].createElement("a", { "data-tip": true, ref: ref => tRef = ref, "data-for": uniqueIdentifier(), ...defineLinkPropsIfLink(), "data-automation-id": dataAutomationId ? `${dataAutomationId}_tooltip_base` : '', className: `text-base cursor-pointer ${triggerClassName} ${triggerDecorationClassName}`, onClick: onClickHandler }, tooltipTriggerType),
            React__default["default"].createElement("span", { tabIndex: 0, className: `gi-tooltip ${contentClassName}`, "data-automation-id": dataAutomationId ? `${dataAutomationId}_tooltip_content` : '', onFocus: () => showTooltip(tRef), onBlur: () => hideTooltip(tRef), onKeyUp: (e) => onKeyUpEvent(e, tRef) },
                React__default["default"].createElement(ReactTooltip__default["default"], { place: place, type: type, effect: effect, className: 'tooltip-component', id: uniqueIdentifier(), multiline: multiline }, typeof content === 'string' && !plain ? parse__default["default"](intlApi.formatMessage({ id: content }, contentReplacement)) : content)));
    };
    Tooltip.propTypes = {
        id: PropTypes__default["default"].string.isRequired,
        content: PropTypes__default["default"].string.isRequired,
        index: PropTypes__default["default"].string,
        elementId: PropTypes__default["default"].string,
        href: PropTypes__default["default"].string,
        replacement: PropTypes__default["default"].any,
        place: PropTypes__default["default"].oneOf(['left', 'top', 'right', 'bottom']),
        type: PropTypes__default["default"].oneOf(['dark', 'success', 'warning', 'error', 'info', 'light']),
        effect: PropTypes__default["default"].oneOf(['solid', 'float']),
        icon: PropTypes__default["default"].any,
        empty: PropTypes__default["default"].bool,
        triggerClassName: PropTypes__default["default"].string,
        contentClassName: PropTypes__default["default"].string,
        triggerDecorationClassName: PropTypes__default["default"].string,
        dataAutomationId: PropTypes__default["default"].string,
        plain: PropTypes__default["default"].bool,
        multiline: PropTypes__default["default"].bool,
        contentReplacement: PropTypes__default["default"].any,
        onClickHandler: PropTypes__default["default"].func
    };
    Tooltip.defaultProps = {
        elementId: undefined,
        place: 'top',
        type: 'dark',
        effect: 'solid',
        icon: undefined,
        empty: false,
        triggerClassName: '',
        contentClassName: '',
        triggerDecorationClassName: 'tooltip-base',
        dataAutomationId: undefined,
        plain: false,
        multiline: false,
    };

    const EditableField = (props) => {
        const { column, displayValueFormatter, isBelow, isEditActive, isRequired, labelId, maxChars, name, onCancelHandler, onChangeHandler, onEditToggleHandler, onSaveHandler, placeholder, registeredInputs, rows, showReadOnlyModeButton, type, validators, value } = props;
        const [isEditing, setIsEditing] = React.useState(false);
        const [validationError, setValidationError] = React.useState('');
        const [inputValue, setInputValue] = React.useState('');
        React.useEffect(() => {
            if (isEditActive !== undefined) {
                setIsEditing(isEditActive);
            }
        }, [isEditActive]);
        React.useEffect(() => {
            if (value !== undefined) {
                setInputValue(value);
            }
        }, [value]);
        React.useEffect(() => {
            if (onEditToggleHandler) {
                onEditToggleHandler(isEditing);
            }
        }, [isEditing]);
        React.useEffect(() => {
            if (isEditing && registeredInputs && type === 'textarea') {
                setTimeout(() => {
                    const start = registeredInputs.current.selectionStart;
                    const position = start + (registeredInputs.current.value || "").length;
                    registeredInputs.current.selectionStart = position;
                    registeredInputs.current.selectionEnd = position;
                }, 100);
            }
        }, [isEditing, registeredInputs, type]);
        const handleInputChange = (e) => {
            setValidationError('');
            setInputValue(e.target.value);
            if (onChangeHandler) {
                onChangeHandler(e.target.value);
            }
        };
        const handleEditClick = () => {
            setIsEditing(true);
        };
        const handleCancelClick = () => {
            setInputValue(value || '');
            setIsEditing(false);
            setValidationError('');
            if (onCancelHandler) {
                onCancelHandler();
            }
        };
        const handleSaveClick = () => {
            let isValidInput = true;
            if (validators.length) {
                isValidInput = validators.every((v) => {
                    if (!v.validatorFn(inputValue)) {
                        setValidationError(v.errorMessage);
                        return false;
                    }
                    return true;
                });
            }
            if (isValidInput) {
                if (onSaveHandler) {
                    onSaveHandler(inputValue).then((v) => {
                        if (v) {
                            setIsEditing(false);
                        }
                    });
                }
                else {
                    setIsEditing(false);
                }
            }
        };
        const LabelText = React__default["default"].createElement(reactIntl.FormattedMessage, { id: labelId });
        const FieldLabel = (React__default["default"].createElement("label", { "data-testid": "field-label", htmlFor: name, className: `gi-input__label margin-bottom-0 required-${isRequired}` }, LabelText));
        const EditModeButtons = () => {
            return (React__default["default"].createElement(React.Fragment, null,
                React__default["default"].createElement(GIButton, { "data-automation-id": `btn-cancel-${name}`, "data-variant": 'secondary', icon: 'fas fa-times', iconPlacement: 'start', id: `btn-cancel-${name}`, isDisabled: false, labelId: 'label.cancel', name: name, onClickHandler: handleCancelClick, size: 'small', type: 'button', variant: 'secondary' }),
                React__default["default"].createElement(GIButton, { "data-automation-id": `btn-save-${name}`, "data-variant": 'secondary', icon: 'fas fa-save', iconPlacement: 'start', id: `btn-save-${name}`, isDisabled: false, labelId: 'label.save', name: name, onClickHandler: handleSaveClick, size: 'small', type: 'button', variant: 'primary' })));
        };
        const ReadOnlyModeButtons = () => {
            return (React__default["default"].createElement(GIButton, { "data-automation-id": `btn-edit-${name}`, "data-variant": 'secondary', icon: 'fas fa-edit', iconPlacement: 'start', id: `btn-edit-${name}`, isDisabled: false, labelId: 'label.edit', name: name, onClickHandler: handleEditClick, size: 'small', type: 'button', variant: 'secondary' }));
        };
        const ReadOnlyModeView = () => {
            return (React__default["default"].createElement(React.Fragment, null,
                React__default["default"].createElement("span", { "data-testid": "labelViewValue", className: 'display-flex margin-right-105' }, displayValueFormatter ? displayValueFormatter(inputValue) : inputValue)));
        };
        const EditModeView = () => {
            return (React__default["default"].createElement(React.Fragment, null, type === 'textarea' ? (React__default["default"].createElement("textarea", { rows: rows, cols: column, autoFocus: true, id: name, "data-testid": `textarea-${name}`, name: name, maxLength: maxChars, ref: registeredInputs, placeholder: placeholder, value: inputValue, onChange: handleInputChange })) : (React__default["default"].createElement("input", { autoFocus: true, id: name, "data-testid": `input-${name}`, name: name, type: type, ref: registeredInputs, placeholder: placeholder, value: inputValue, onChange: handleInputChange }))));
        };
        const InlineActionsEditorView = (React__default["default"].createElement("div", { className: `display-flex flex-align-${validationError ? 'start' : 'center'}` },
            FieldLabel,
            React__default["default"].createElement("div", { className: "display-flex flex-column" },
                React__default["default"].createElement("div", { className: 'display-flex align-items-center edit-buttons' },
                    isEditing && (React__default["default"].createElement(React__default["default"].Fragment, null,
                        EditModeView(),
                        React__default["default"].createElement(EditModeButtons, null))),
                    !isEditing && (React__default["default"].createElement(React__default["default"].Fragment, null,
                        React__default["default"].createElement(ReadOnlyModeView, null),
                        showReadOnlyModeButton &&
                            React__default["default"].createElement(ReadOnlyModeButtons, null)))),
                validationError &&
                    React__default["default"].createElement("span", { className: 'text-danger' },
                        React__default["default"].createElement(reactIntl.FormattedMessage, { id: validationError })))));
        const BelowActionsEditorView = (React__default["default"].createElement("div", { className: 'display-flex flex-column' },
            React__default["default"].createElement("div", { className: `display-flex align-items-center edit-buttons` },
                FieldLabel,
                isEditing ? React__default["default"].createElement(EditModeButtons, null) : React__default["default"].createElement(ReadOnlyModeButtons, null)),
            React__default["default"].createElement("div", { className: `display-flex align-items-center edit-buttons` },
                React__default["default"].createElement("div", { className: 'display-flex flex-column', "data-testid": "is-below" },
                    React__default["default"].createElement("div", { className: 'padding-2' }, isEditing ? EditModeView() : React__default["default"].createElement(ReadOnlyModeView, null)),
                    React__default["default"].createElement("div", { className: 'padding-2' }, validationError &&
                        React__default["default"].createElement("span", { className: 'text-danger' },
                            React__default["default"].createElement(reactIntl.FormattedMessage, { id: validationError })))))));
        return (React__default["default"].createElement("div", { className: 'display-flex align-items-center padding-bottom-105 readOnly-buttons' }, isBelow ? BelowActionsEditorView : InlineActionsEditorView));
    };
    EditableField.propTypes = {
        labelId: PropTypes__default["default"].string.isRequired,
        name: PropTypes__default["default"].string.isRequired,
        type: PropTypes__default["default"].oneOf(['text', 'number', 'email', 'textarea', 'date']),
        isBelow: PropTypes__default["default"].bool,
        isRequired: PropTypes__default["default"].bool,
        placeholder: PropTypes__default["default"].string,
        registeredInputs: PropTypes__default["default"].any,
        value: PropTypes__default["default"].string,
        rows: PropTypes__default["default"].number,
        column: PropTypes__default["default"].number,
        maxChars: PropTypes__default["default"].number,
        maxRows: PropTypes__default["default"].number,
        onSaveHandler: PropTypes__default["default"].func,
        onCancelHandler: PropTypes__default["default"].func,
        onChangeHandler: PropTypes__default["default"].func,
        onEditToggleHandler: PropTypes__default["default"].func,
        isEditActive: PropTypes__default["default"].bool,
        showReadOnlyModeButton: PropTypes__default["default"].bool,
        validators: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
            validatorFn: PropTypes__default["default"].func,
            errorMessage: PropTypes__default["default"].string
        })),
        displayValueFormatter: PropTypes__default["default"].func
    };
    EditableField.defaultProps = {
        type: 'text',
        validators: [],
        isEditActive: false,
        showReadOnlyModeButton: true,
        value: '',
        row: 20,
        column: 50,
        isRequired: false,
        isBelow: false
    };

    const DescriptionList = (props) => {
        const { dlId, title, variant, data, dataTestId, addlClassNames } = props;
        const dlClassNames = classnames__default["default"]({
            'dl_row-inline': variant === 'inline',
            'dl_column-block': variant === 'block',
            'dl_row-block': variant === 'inline-block',
            [`${addlClassNames}`]: addlClassNames
        });
        return (React__default["default"].createElement("dl", { id: dlId, title: title, "data-automation-id": dlId, "data-testid": dataTestId, className: dlClassNames }, data &&
            data.map((item, indx) => {
                return (React__default["default"].createElement("span", { key: indx },
                    React__default["default"].createElement("dt", null,
                        item.dtLabelId && (React__default["default"].createElement("span", null,
                            React__default["default"].createElement(reactIntl.FormattedMessage, { id: item.dtLabelId }))),
                        item.dtLabel && React__default["default"].createElement("span", null, item.dtLabel)),
                    React__default["default"].createElement("dd", null,
                        item.ddLabelId && (React__default["default"].createElement(reactIntl.FormattedMessage, { id: item.ddLabelId })),
                        item.ddLabel && React__default["default"].createElement("span", null, item.ddLabel),
                        item.ddElement && item.ddElement)));
            })));
    };
    DescriptionList.propTypes = {
        dlId: PropTypes__default["default"].string.isRequired,
        title: PropTypes__default["default"].string.isRequired,
        variant: PropTypes__default["default"].oneOf(['inline', 'block', 'inline-block']),
        dataTestId: PropTypes__default["default"].string,
        data: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
            dtLabel: PropTypes__default["default"].string,
            dtLabelId: PropTypes__default["default"].string,
            ddLabel: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].number]),
            ddLabelId: PropTypes__default["default"].string,
            ddElement: PropTypes__default["default"].string
        }))
    };
    DescriptionList.defaultProps = {
        dlId: 'dl',
        data: [],
        title: '',
        variant: 'inline'
    };

    exports.Button = Button;
    exports.Cards = Cards;
    exports.CollapsiblePanel = CollapsiblePanel;
    exports.DescriptionList = DescriptionList;
    exports.EditableField = EditableField;
    exports.GIButton = GIButton;
    exports.HeaderNav = HeaderNav;
    exports.Layouts = Layouts;
    exports.Modal = Modal;
    exports.NavBar = NavBar;
    exports.PageTitle = PageTitle;
    exports.PrivateRoute = PrivateRoute;
    exports.SideNav = SideNav;
    exports.Spinner = Spinner;
    exports.Table = Table;
    exports.Tabs = Tabs;
    exports.Tooltip = Tooltip;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
